var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "field-subtext pr-2",
      attrs: {
        "aria-hidden": _vm.fieldData.sub_text === "" ? "true" : "false",
        id:
          _vm.fieldData.sub_text === ""
            ? _vm.fieldData.field_name + "_describedby"
            : _vm.fieldData.field_name + "_non"
      }
    },
    [
      _vm.fieldData.sub_text
        ? _c("div", {
            staticClass: "form-text smaller-font-content",
            attrs: { id: _vm.fieldData.field_name + "_describedby" },
            domProps: { innerHTML: _vm._s(_vm.fieldData.sub_text) },
            on: {
              "!click": function($event) {
                return _vm.generate_rnd_email_address(
                  $event,
                  _vm.fieldData.field_name
                )
              }
            }
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f4ef2a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f4ef2a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/presentational/FieldSubtext.vue
// module id = null
// module chunks = 